// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__mu1n4","sep":"Breadcrumb_sep__zqsP+","link":"Breadcrumb_link__20jvt","current":"Breadcrumb_current__vAdMc"};